import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  /**
   * Messages for the AI Global Opt-in component
   */
  aiOptInDialogHeaderText: {
    id: 'ai-opt-in.dialog.header.text',
    defaultMessage: 'Work smarter, not harder',
    description: 'Header text for AI Opt In Dialog'
  },
  aiOptInDialogBodyText: {
    id: 'ai-opt-in.dialog.body.text',
    defaultMessage: 'Get up to speed and consume information with ease, thanks to your virtual teammate. Share interest with your admin so they know to opt-in to Atlassian Intelligence.',
    description: 'Body text for AI Opt In Dialog'
  },
  aiOptInDialogLearnMoreLinkText: {
    id: 'ai-opt-in.dialog.learn-more.link.text',
    defaultMessage: 'Learn more about Atlassian Intelligence',
    description: 'Learn more link text for AI Opt In Dialog'
  },
  aiOptInDialogAdminBodyText: {
    id: 'ai-opt-in.dialog.admin.body.text',
    defaultMessage: 'Get everyone up to speed quickly and consume information with ease, thanks to your virtual teammate.',
    description: 'Body text for Admin version of AI Opt In Dialog'
  },
  aiOptInDialogAdminTurnOnText: {
    id: 'ai-opt-in.dialog.admin.turn-on.part-one.text',
    defaultMessage: 'Turn on <a>Atlassian Intelligence</a> features for your users from Atlassian Administration.',
    description: 'Turn on AI text'
  },
  aiOptInDialogAdminCloseButtonText: {
    id: 'ai-opt-in.dialog.admin.close.button.text',
    defaultMessage: 'Close',
    description: 'Admin close button text'
  },
  aiOptInDialogAdminLetsGoButtonText: {
    id: 'ai-opt-in.dialog.admin.lets-go.button.text',
    defaultMessage: "Let's go!",
    description: 'Admin Lets go button text'
  }
});